import React, {FC, ReactElement, useEffect, useMemo, useState} from "react";
import {billingApi} from "../../backend/BillingApi";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {loadStripe} from "@stripe/stripe-js/pure";
import {Elements} from "@stripe/react-stripe-js";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import {IReactComponent} from "mobx-react/dist/types/IReactComponent";

interface IProps {
}

const WithStripe: FC<IProps> = (props): ReactElement => {
    const [pubKey, setKey] = useState<string>('');

    useEffect(() => {
        if (selectedCompanyStore.companyId) {
            billingApi.fetchKey(selectedCompanyStore.companyId)
                .then(data => {
                    setKey(data.key)
                })
        }
    }, []);

    const stripe = useMemo(() => {
        if (pubKey) {
            return loadStripe(pubKey);
        } else {
            return null;
        }
    }, [pubKey]);

    // @ts-ignore
    return <>
        <LoaderWithCompanySelected loading={!stripe}>
            <Elements stripe={stripe}>
                {props.children}
            </Elements>
        </LoaderWithCompanySelected>
    </>;
};


export const withStripe = <T extends IReactComponent>(Component: T): T => {
    // @ts-ignore
    return (props: any) => <WithStripe>
        <Component {...props}/>
    </WithStripe>
};